module.exports = "https://s91588.cdn.ngenix.net/news-frontend/_next/static/images/subscription-d1384ae7cf228bcda92d271f9b1545be.svg";